export enum QuestionType {
  Text = 'text',
  Scale = 'scale',
}

export const QUESTION_TYPE_MAP: Record<number, QuestionType> = {
  7: QuestionType.Text,
  8: QuestionType.Scale,
  1: QuestionType.Scale,
  2: QuestionType.Scale,
  3: QuestionType.Scale,
  4: QuestionType.Scale,
  5: QuestionType.Scale,
  6: QuestionType.Scale,
  9: QuestionType.Scale,
  10: QuestionType.Scale,
  11: QuestionType.Scale,
  12: QuestionType.Scale,
  13: QuestionType.Scale,
  14: QuestionType.Scale,
  15: QuestionType.Scale,
  16: QuestionType.Scale,
  17: QuestionType.Scale,
  18: QuestionType.Scale,
  19: QuestionType.Scale,
  20: QuestionType.Scale,
  21: QuestionType.Scale,
  22: QuestionType.Scale,
  23: QuestionType.Scale,
  24: QuestionType.Scale,
  25: QuestionType.Scale,
  26: QuestionType.Scale,
  27: QuestionType.Scale,
  28: QuestionType.Scale,
  29: QuestionType.Text,
  30: QuestionType.Text,
};

export const QUESTION_SCALE_LABELS: Record<number, string[]> = {
  4: [
    'Not Managed',
    'Minimally Managed',
    'Managed',
    'Well Managed',
    'Fully Managed',
  ],
  5: [
    'No Improvement',
    'Minimal Improvement',
    'Moderate Improvement',
    'Significant Improvement',
    'Fully Improved',
  ],
  6: [
    'Not Effective',
    'Somewhat Effective',
    'Effective',
    'Very Effective',
    'Fully Effective',
  ],
  8: [
    'No Impact',
    'Minimal Impact',
    'Moderate Impact',
    'Significant Impact',
    'Full Impact',
  ],
  12: [
    'Very Unsatisfied',
    'Unsatisfied',
    'Neutral',
    'Satisfied',
    'Very Satisfied',
  ],
  11: [
    'Very Poor Progress',
    'Poor Progress',
    'Neutral Progress',
    'Good Progress',
    'Very Good Progress',
  ],
};
